<template>
  <b-modal 
    v-model="showModal"
    ok-title="Go to Kickoff"
    cancel-title="Okay"
    @ok="goToKickoff"
    @cancel="cancel"
    @hide="cancel"
  >
    
    <template v-slot:modal-title>
      <span class="d-flex align-items-center">
        <font-awesome-icon
          :icon="['fa', 'cogs']"
          size="2x"
          class="wizard__icon mr-3">
        </font-awesome-icon>
        <span class="d-inline-block pt-1">Project Setup: Hold Kickoff Meeting</span>
      </span>
      
    </template>
    <p>Your kickoff meeting is scheduled for {{ date }} at {{ startTime }}.</p>
    <p>Meeting link:</p>
    <p>
      <router-link :to="kickoffPath" class="text-break">
        {{ fullKickoffUrl }}
      </router-link>
    </p>
  </b-modal>
</template>

<script>
export default {
  props: {
    projectId: { type: String, required: true },
    kickoff: { type: Object, required: true }
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    startDateTime() {
      return this.kickoff.start;
    },
    date() {
      return this.$helpers.formatDateWithRelativeWords( this.startDateTime );
    },
    startTime() {
      return this.$helpers.formatTime( this.startDateTime );
    },
    kickoffPath() {
      return `/project/${this.projectId}/meeting-kickoff/${this.kickoff.meetingId}`;
    },
    fullKickoffUrl() {
      return `${window.location.origin}${this.kickoffPath}`;
    }
  },
  mounted() {
    this.show();
  },
  methods: {
    show(){
      this.showModal = true;
    },
    hide(){
      this.showModal = false;
    },
    cancel() {
      this.$emit('cancel');
    },
    goToKickoff() {
      this.$router.push( this.kickoffPath );
    }
  }
}
</script>